/* eslint-disable indent */
import { EActivityType } from '@constants';
import { ILast14DaysActivity } from '@sdk/contracts';
import { dateProvider } from '@utils';
import { useTranslation } from 'react-i18next';

import {
  DateTitle,
  DateValue,
  DateWrapper,
  IconWrapper,
  ItemWrapper,
  SubtitleWrapper,
  TextWrapper,
  TitleWrapper,
  Wrapper
} from './ActivityItem.styles';

import { Icon } from '@/components/Icon';
import { ACTIVITY_ICONS } from '@/constants';
import { useDeliverableByActivity, useLastQuizResultByQuizId } from '@/store';
import { formatDuration } from '@/utils';

type Props = {
  activityTrack: ILast14DaysActivity;
};

export const ActivityItem: React.FC<Props> = ({ activityTrack }) => {
  const { activity } = activityTrack;
  const { t } = useTranslation(['DefaultTranslations', 'StudentCourseSummaryTranslations']);
  const { quizResult } = useLastQuizResultByQuizId(activity.resource?.quiz?._id);
  const { deliverable } = useDeliverableByActivity(activity._id);

  const getActivityDescription = () => {
    const { type, resource } = activity;
    if (type === EActivityType.VIDEO) {
      const duration = resource?.file ? formatDuration(resource?.file.duration) : 0;
      return t('StudentCourseSummaryTranslations:VIDEO_DESCRIPTION', { duration });
    }
    if (type === EActivityType.PDF) return t('StudentCourseSummaryTranslations:PDF_DESCRIPTION');
    if (type === EActivityType.QUIZ)
      return quizResult
        ? t('StudentCourseSummaryTranslations:QUIZ_DESCRIPTION_WITH_SCORE', {
            score: quizResult.score
          })
        : t('StudentCourseSummaryTranslations:QUIZ_DESCRIPTION', {
            questions: resource?.quiz?.questions.length
          });
    if (type === EActivityType.DELIVERABLE)
      return deliverable?.score
        ? t('StudentCourseSummaryTranslations:DELIVERABLE_DESCRIPTION_WITH_SCORE', {
            score: deliverable.score
          })
        : deliverable
        ? t('StudentCourseSummaryTranslations:DELIVERABLE_DESCRIPTION_SENT')
        : t('StudentCourseSummaryTranslations:DELIVERABLE_DESCRIPTION');
    if (type === EActivityType.TEXT) return t('StudentCourseSummaryTranslations:TEXT_DESCRIPTION');

    return undefined;
  };

  return (
    <ItemWrapper>
      <Wrapper>
        <IconWrapper>
          <Icon i={ACTIVITY_ICONS[activity.type]} />
        </IconWrapper>
        <TextWrapper>
          <TitleWrapper>{activity.name}</TitleWrapper>
          <SubtitleWrapper>{getActivityDescription()}</SubtitleWrapper>
        </TextWrapper>
      </Wrapper>
      <DateWrapper>
        <DateTitle>{t('DefaultTranslations:DONE_ON')}</DateTitle>
        <DateValue>{dateProvider.format(activityTrack.updatedAt, 'dd/MM/yyyy')}</DateValue>
      </DateWrapper>
    </ItemWrapper>
  );
};
